import type { PropsWithChildren } from "react";
import { Layout as BaseLayout } from "@ptsd/uikit";
import { ScrollView, useMedia, useWindowDimensions, View } from "tamagui";

import { Plug } from "../blocks";
import { Footer } from "./footer";
import { Header } from "./header";

const HEADER_HEIGHT_DESKTOP = 84;
const HEADER_HEIGHT_MOBILE = 58;
const MAX_WIDTH = 1200;
const HORIZONTAL_PADDING = 48;

export const MainLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <BaseLayout>
      <Header />
      {children}
    </BaseLayout>
  );
};

export const MainPageWrapper: React.FC<
  PropsWithChildren & {
    subheader?: React.ReactNode;
  }
> = ({ children, subheader }) => {
  const { height } = useWindowDimensions();
  const { sm, md } = useMedia();
  return (
    <ScrollView
      height={
        sm ? height - HEADER_HEIGHT_MOBILE : height - HEADER_HEIGHT_DESKTOP
      }
    >
      {subheader}
      <View width="100%" alignItems="center">
        <View
          maxWidth={MAX_WIDTH + HORIZONTAL_PADDING}
          width={"100%"}
          paddingTop={"$4.2"}
          paddingBottom={"$8.1"}
          paddingHorizontal="$3"
        >
          {md ? <Plug /> : children}
        </View>
      </View>

      <Footer maxWidth={MAX_WIDTH + HORIZONTAL_PADDING} alignSelf="center" />
    </ScrollView>
  );
};

// Explanation: We calculate leftPad from the max width and the window width caz
// Anton wants the scrollbar to appear on the right side of the page,
// not on the right side of the content.

export const MetricsLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { width } = useWindowDimensions();
  const leftPad = (width - MAX_WIDTH) / 2;

  const { md } = useMedia();

  if (md) {
    return <MainPageWrapper>{children}</MainPageWrapper>;
  }

  return (
    <View
      flexDirection="row"
      paddingLeft={
        leftPad < HORIZONTAL_PADDING / 2 ? HORIZONTAL_PADDING / 2 : leftPad
      }
    >
      {children}
    </View>
  );
};

const MAX_WIDTH_OF_THE_CONTENT = 1000;

export const MetricsPageWrapper: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { height } = useWindowDimensions();
  const { sm } = useMedia();
  return (
    <ScrollView
      height={
        sm ? height - HEADER_HEIGHT_MOBILE : height - HEADER_HEIGHT_DESKTOP
      }
    >
      <View
        alignSelf="flex-start"
        maxWidth={MAX_WIDTH_OF_THE_CONTENT}
        width={"100%"}
        paddingTop={"$4.2"}
        paddingBottom={"$8.1"}
        paddingHorizontal="$3"
      >
        {children}
      </View>
      <View paddingHorizontal="$3">
        <Footer maxWidth={MAX_WIDTH_OF_THE_CONTENT} alignSelf="flex-start" />
      </View>
    </ScrollView>
  );
};
